"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseXml = void 0;
const fast_xml_parser_1 = require("fast-xml-parser");
const options = {
    ignoreAttributes: false,
};
const parser = new fast_xml_parser_1.XMLParser(options);
/**
 * Parses the provided XML text into a JavaScript object.
 *
 * @param xmlText - The XML text to parse.
 * @returns A JavaScript object representation of the XML.
 */
function parseXml(xmlText) {
    return parser.parse(xmlText);
}
exports.parseXml = parseXml;
